export const DEFAULT_APP_LOCALE = "en";

const APP_LOCALE_STORAGE_KEY = "tmtt.app.locale";

export function normalizeAppLocale(value) {
  return value === "ko" || value === "en" ? value : DEFAULT_APP_LOCALE;
}

export function getStoredAppLocale() {
  if (typeof window === "undefined") {
    return DEFAULT_APP_LOCALE;
  }

  return normalizeAppLocale(window.localStorage.getItem(APP_LOCALE_STORAGE_KEY));
}

export function setStoredAppLocale(value) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(APP_LOCALE_STORAGE_KEY, normalizeAppLocale(value));
}
